var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isAnon && (_vm.item.isGroup || _vm.item.isTag || _vm.item.isUser))?_c('v-btn',{staticClass:"context-menu-btn",attrs:{"small":_vm.small,"x-small":_vm.xSmall,"icon":""},on:{"click":_vm.onClick}},[_c('v-icon',{attrs:{"small":_vm.small,"x-small":_vm.xSmall}},[_vm._v(_vm._s(_vm.icon))])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }